"use client"
import classNames from "classnames";
import { type StreamingProviderContent } from 'src/lib/movieinfo/movieinfotypes';
import styles from "./StreamingProvider.module.css";


//#region [Props]
type StreamingProviderProps = {
    providerContent: StreamingProviderContent;
    className?: string;
};
//#endregion

//#region [Component]
export default function StreamingProvider({ providerContent, className }: StreamingProviderProps) {
    const url = addAffiliate(providerContent.url!, providerContent.provider?.id);
    const logo = providerContent.provider?.logo?.substring(providerContent.provider?.logo?.lastIndexOf("/"));
    // sponsored on all provider links, paid or not, so none is missed (Google expects affiliate links marked).
    // No noreferrer: affiliate programmes may rely on the referrer
    return <a className={classNames(styles.ProviderLink, className)} href={url} target="_blank" rel="sponsored noopener" onClick={() => track(providerContent)}>
        {!logo && <div>{providerContent.provider?.name}</div>}
        {logo && <img className={styles.Img} src={`/providerlogos${logo!}`} alt={providerContent.provider?.name ?? "Innholdsleverandør"} />}
    </a>;
}
//#endregion

//#region [Component]
function addAffiliate(href: string, providerId?: number) {
    const newHref = href;
    switch (providerId) {
        /*
        case 26:
            newHref = `https://hbomax.prf.hn/click/camref:1011lqFg9/pubref:filmweb/ar:filmweb_SG/destination:${href.replace(/:/g, '%3A').replace(/\//g, '%2F')}`;
            //console.debug("Adding affiliate", href, newHref);
            break;
        */
        /*
        case 23:
            const outer = new URL("https://srv.clickfuse.com/ads/adclkr.php?id=100006925");
            outer.searchParams.set("url", href);
            newHref = outer.toString();
            //console.debug("Adding affiliate", href, newHref);
            break;
        */
        default:
    }
    return newHref;
}

function track(providerContent: StreamingProviderContent) {
    window?.dataLayer?.push({
        'event': 'Streamingguiden',
        'eventCategory': 'Streamingklikk',
        'eventAction': providerContent.provider?.name,
        'eventLabel': providerContent.title,
        'eventStreamingId': providerContent.id
    });
}
//#endregion
